import { z } from "zod";

export const refineInvestedRequiresValue =
	(message: string) =>
	(
		data: { value: number | null; invested: number | null },
		ctx: z.RefinementCtx,
	): void => {
		if (data.invested !== null && data.value === null) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ["value"],
				message,
			});
		}
	};
